import React from 'react';
import moment from 'moment';

import { SearchTextField, MCText, MCButton, View, PopoverMenu } from 'src/components/basic';
import { popupModel, TableLibrary } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import {
  remCss,
  lang,
  withRouter,
  addressObject,
  permissions,
  scssVariables as variables,
  api
} from 'src/helpers';

import model from './model';
import ShortInfo from 'src/components/user/ShortInfo';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import LANG_CONST from 'src/helpers/lang/const';
import { DoctorCardInput, VisitCard } from 'src/components/user/DoctorCard';
import ButtonDropdown from 'src/components/complex/ButtonDropdown';
import AlertManager from 'src/components/alert/AlertManager';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';

class VisitCardOrder extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let { total = 0 } = model.getCurrent();
    let pageSize = model.listLimit;

    const columns = [
      {
        label: '#',
        resize: true,
        width: '5%',
        renderCell: (item, i) => pageSize * model.state.pageIndex + i + 1
      },
      {
        label: LANG_CONST.name,
        resize: true,
        renderCell: (item) => {
          return (
            <div className={'mc-flex-5-col'}>
              <View
                style={{
                  flexDirection: 'row'
                }}
              >
                <ShortInfo user={item?.doctor} vertical={true} />

                <View
                  style={{
                    alignItems: 'center'
                  }}
                >
                  <MCButton
                    label={LANG_CONST.buttons.view}
                    small
                    radius
                    primary
                    light
                    onClick={() => {
                      permissions.switchToFront();
                      model.logAsDoctor(item?.doctor);
                    }}
                  />
                </View>
              </View>
              <MCText size={18} weight={400}>
                {item?.doctor?.email}
              </MCText>
              <MCText size={18} weight={400}>
                {formatPhoneNumberIntl(
                  (item?.phoneNumber || item?.doctor?.phoneNumber || '').toString()
                )}
              </MCText>
              <MCText size={18} weight={400}>
                {item.date ? moment(item.date).format('MMMM D, YYYY') : ''}
              </MCText>
            </div>
          );
        }
      },
      {
        label: LANG_CONST.delivery_address,
        resize: true,
        minWidth: '120',
        width: '20%',
        renderCell: (item) => {
          const addressData = addressObject(item);
          return (
            <>
              <MCText
                label={item.address + ' ' + addressData.fullAddressNameReverse + ' ' + item.zipcode}
              />
              <div className={'mc-flex'} style={{ justifyContent: 'flex-end' }}>
                <MCButton
                  iconname={BASE_ICONS.EDIT}
                  fill={variables['colors-mc-primary']}
                  light
                  radius
                  padding={5}
                  width={30}
                  onClick={async (e) => {
                    e.preventDefault();
                    const res = await api('admin/visitCardOrder/detail', { id: item.id });
                    popupModel.setActivePopup('order_doctor_card', {
                      active: true,
                      component: DoctorCardInput,
                      props: {
                        item: res.data,
                        model,
                        isEdit: true,
                        doctor: item.doctor,
                        afterSave: (res) => {
                          model.updateItem({ ...item, ...res.data });
                        }
                      }
                    });
                  }}
                />
              </div>
            </>
          );
        }
      },
      {
        label: LANG_CONST.actions,
        resize: true,
        minWidth: '180',
        sort: { sortKey: 'status' },
        width: '15%',
        renderCell: (item) => (
          <>
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'flex-end',
                gap: remCss(10),
                alignItems: 'center'
              }}
            >
              <View style={{ maxWidth: 250, flex: 1 }}>
                <ButtonDropdown
                  iconProps={{
                    hover: false,
                    light: false,
                    style: { borderBottomRightRadius: 5, borderTopRightRadius: 5 }
                  }}
                  menu={(toggle) => (
                    <>
                      {Object.keys(LANG_CONST.constants.card_order_status).map(
                        (key) =>
                          !['cancelled_by_doctor', item.status].includes(key) && (
                            <MCButton
                              medium
                              hover
                              base
                              key={key}
                              style={{ width: '100%', justifyContent: 'flex-start' }}
                              radius={false}
                              disabled={model.getApiState('status').loading}
                              onClick={(e) => {
                                e.preventDefault();
                                toggle();
                                if (key === 'cancelled') {
                                  AlertManager.popup(AlertManager.TYPES.WARN, {
                                    close: false,
                                    title: LANG_CONST.notice.cancel,
                                    cancelButton: {
                                      label: LANG_CONST.buttons.no,
                                      action: (actions) => actions.hide()
                                    },
                                    actionButton: {
                                      label: LANG_CONST.buttons.yes,
                                      action: (actions) => {
                                        actions.setLoading(true);
                                        model.updateStatus(item, key, () => {
                                          actions.setLoading(false);
                                          actions.hide();
                                        });
                                      }
                                    }
                                  });
                                } else model.updateStatus(item, key);
                              }}
                              label={LANG_CONST.constants.card_order_status[key]}
                            />
                          )
                      )}
                    </>
                  )}
                  mainButton={(toggle) => (
                    <>
                      <MCButton
                        medium
                        hover={false}
                        radius
                        flex
                        style={{
                          border: 'none',
                          justifyContent: 'flex-start'
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          toggle();
                        }}
                        label={LANG_CONST.constants.card_order_status[item.status || 'pending']}
                      />
                    </>
                  )}
                />
              </View>
            </View>
          </>
        )
      },
      {
        label: LANG_CONST.card_preview,
        width: `${remCss(450)}px`,
        renderCell: (item) => (
          <>
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                minWidth: remCss(540),
                padding: remCss(15)
              }}
            >
              <VisitCard
                doctor={item.doctor}
                scale={0.8}
                onClick={(e) => {
                  e.preventDefault();
                  popupModel.setActivePopup('card_preview', {
                    active: true,
                    component: ({ closeBtn }) => {
                      return (
                        <View style={{ zIndex: 1 }}>
                          <View
                            style={{ position: 'absolute', top: remCss(10), right: remCss(10) }}
                          >
                            {closeBtn}
                          </View>

                          <VisitCard doctor={item.doctor} scale={1} />
                        </View>
                      );
                    }
                  });
                }}
              />
            </View>
          </>
        )
      },
      {
        label: '',
        width: `${remCss(65)}px`,
        renderCell: (item) => (
          <View style={{ alignSelf: 'flex-start', justifySelf: 'flex-end' }}>
            <PopoverMenu
              triggerOffset={10}
              arrowOffset={-30}
              placement={'bottom-end'}
              popupMenuStyle={{
                backgroundColor: 'white',
                padding: remCss(10),
                overflow: 'none'
              }}
              menu={() => (
                <>
                  <MCButton
                    iconname={BASE_ICONS.DELETE}
                    width={42}
                    light
                    radius
                    secondary
                    padding={5}
                    onClick={(e) => {
                      e.preventDefault();
                      model.remove(item);
                    }}
                  />
                </>
              )}
              className={'mc-pointer mc-flex mc-flex-center'}
            >
              {(isOpen, toggle) => (
                <MCButton primary tiny outline radius hover onClick={toggle}>
                  <span
                    className={'mc-rotate ' + (isOpen ? 'mc-rotate-180' : '')}
                    style={{ height: remCss(42), width: remCss(42) }}
                  >
                    <SVGIcon
                      iconname={BASE_ICONS.DOWN}
                      width={42}
                      padding={7}
                      fill={variables['colors-mc-primary']}
                    />
                  </span>
                </MCButton>
              )}
            </PopoverMenu>
          </View>
        )
      }
    ].filter((v) => !!v);

    return (
      <div className={'mc-container-content mc-all-patients'}>
        <div className={'mc-container-content__header mc-flex-15'}>
          <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.printer_request)}</span>
          <SearchTextField
            width={300}
            template={'2'}
            onChange={(text) => {
              model.setStateSilent({
                pageIndex: 0
              });
              model.setListStateSilent({ items: [], total: 0 }, 'search');
              model.handleChangeSearch(text);
              if (!text) {
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.refresh();
              }
            }}
            value={model.listInput('search')}
          />
        </div>
        <div className={'mc-container-content__body'}>
          <div
            className={'mc-container-content__body-content'}
            style={{ marginTop: remCss(25), zIndex: 0 }}
          >
            <TableLibrary
              loading={loading}
              noResults={noResults}
              searchQuery={searchQuery}
              sortBy={model.state.sortBy}
              selectedPage={model.state.pageIndex}
              total={total}
              limit={model.listLimit}
              onSortChange={(sortBy) => {
                model.handleChange('sortBy', sortBy);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              onSetPage={(v) => {
                model.handleChange('pageIndex', v);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              columns={columns}
              data={items}
              otherProps={{
                cell: (col, colIndex) => ({
                  style: {
                    alignItems: 'flex-start',
                    ...(colIndex === columns.length - 2 ? { padding: 0 } : {})
                  }
                })
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(VisitCardOrder);
